module.exports = "//static.hsappstatic.net/ContentUtils/static-1.60430/img/choiceButtons/fill-rectangle.svg"